<template>
  <div class="mb-10">
    <div class="d-flex">
      <page-title value="一斉メッセージ"></page-title>

      <v-spacer></v-spacer>

      <v-btn color="primary" variant="flat" to="/mail/new">
        <v-icon start>mdi-plus</v-icon>
        新規作成
      </v-btn>
    </div>

    <v-alert
      class="my-4"
      type="info"
      color="primary"
      variant="outlined"
      density="compact"
      style="font-size: 0.9rem"
    >
      ここで送信されたメッセージは、モバイルアプリ「CCS」の一斉メッセージで作成されたメールと同様に、保護者用アプリ「CCS
      HOME」のチャット画面に送信されます。<br />
      以下に表示されている一覧画面には、当画面から送信されたメッセージとモバイルアプリから送信されたメッセージの両方が表示されています。
    </v-alert>

      <v-tabs v-model="tab" color="primary">
        <v-tab value="delivered">配信済み</v-tab>  
        <v-tab value="inProgress">配信中</v-tab>
        <v-tab value="inDraft">下書き</v-tab>
      </v-tabs>

    <v-window v-model="tab">
      <v-window-item value="delivered">
        <v-card variant="flat" elevation="2" class="mt-6 pa-2" color="grey-lighten-5"> 
          <v-container fluid>
            <v-row>
              <v-col cols="3">
                <div class="pb-4">日付で絞り込み</div>
                <date-picker
                  v-model="startedAtFilterValue"
                  label="開始日"
                ></date-picker>
              </v-col>
              <v-col cols="3">
                <div class="pb-4"><br /></div>
                <date-picker
                  v-model="endedAtFilterValue"
                  label="終了日"
                ></date-picker>
              </v-col>
              <v-spacer></v-spacer>
              <v-col cols="4">
                <div class="pb-4"><br /></div>
                <v-text-field
                  v-model="titleFilterValue"
                  label="タイトル検索"
                  variant="outlined"
                  density="compact"
                  hide-details
                  color="primary"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="4">
                <div>送信者</div>
                <v-select
                  v-model="userIdFilterValue"
                  :items="staffOptionsList" 
                  item-title="title"
                  item-value="userId"
                  variant="outlined"
                  hide-details
                  clearable
                  density="compact"
                  color="primary"
                >
                  <template v-slot:selection="{ item }">
                    <span v-if="item.value !== 'all'">
                      {{ item.title }}
                    </span>
                  </template>
                </v-select>
              </v-col>
            </v-row>
          </v-container>
        </v-card>

        <div class="pt-10">
          <mail-table-container
            @click="clickDetail"
            @delete="deleteGroupChat"
            :chats="groupChats"
            :loading="loading"
          ></mail-table-container>

          <v-pagination
            class="pt-4"
            v-model="page"
            @update:modelValue="pageClick" :length="Math.ceil(totalItemsCount / limit)"
            active-color="primary"
          >
          </v-pagination>
        </div>
      </v-window-item>

      <v-window-item value="inProgress">
        <v-card variant="flat" elevation="2" class="mt-6 pa-2" color="grey-lighten-5"> 
          <v-container fluid>
            <v-row>
              <v-col cols="3">
                <div class="pb-4">日付で絞り込み</div>
                <date-picker
                  v-model="startedAtFilterValue"
                  label="開始日"
                  color="primary"
                ></date-picker>
              </v-col>
              <v-col cols="3">
                <div class="pb-4"><br /></div>
                <date-picker
                  v-model="endedAtFilterValue"
                  label="終了日"
                  color="primary"
                ></date-picker>
              </v-col>
              <v-spacer></v-spacer>
              <v-col cols="4">
                <div class="pb-4"><br /></div>
                <v-text-field
                  v-model="titleFilterValue"
                  label="タイトル検索"
                  variant="outlined"
                  density="compact"
                  hide-details
                  color="primary"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="4">
                <div>送信者</div>
                <v-select
                  v-model="userIdFilterValue"
                  :items="staffOptionsList" 
                  item-title="title"
                  item-value="userId"
                  variant="outlined"
                  hide-details
                  clearable
                  density="compact"
                  color="primary"
                >
                  <template v-slot:selection="{ item }">
                    <span v-if="item.value !== 'all'">
                      {{ item.title }}
                    </span>
                  </template>
                </v-select>
              </v-col>
            </v-row>
          </v-container>
        </v-card>

        <div class="pt-10">
          <mail-table-container
            @click="clickDetail"
            @delete="deleteGroupChat"
            :chats="groupChats"
            :loading="loading"
          ></mail-table-container>

          <v-pagination
            class="pt-4"
            v-model="page"
            :length="Math.ceil(totalItemsCount / limit)"
            active-color="primary"
          >
          </v-pagination>
        </div>
      </v-window-item>

      <v-window-item value="inDraft">
        <v-card variant="flat" elevation="2" class="mt-6 pa-2" color="grey-lighten-4">
          <v-container fluid>
            <v-row>
              <v-col cols="3">
                <div class="pb-4">日付で絞り込み</div>
                <date-picker
                  v-model="startedAtFilterValue"
                  label="開始日"
                ></date-picker>
              </v-col>
              <v-col cols="3">
                <div class="pb-4"><br /></div>
                <date-picker
                  v-model="endedAtFilterValue"
                  label="終了日"
                ></date-picker>
              </v-col>
              <v-spacer></v-spacer>
              <v-col cols="4">
                <div class="pb-4"><br /></div>
                <v-text-field
                  v-model="titleFilterValue"
                  label="タイトル検索"
                  variant="outlined"
                  density="compact"
                  hide-details
                  color="primary"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card>

        <div class="pt-10">
          <mail-table-container
            :loading="loading"
            @click="clickDetail"
            @delete="deleteGroupChat"
            :chats="drafts"
          ></mail-table-container>

          <v-pagination
            class="pt-4"
            v-model="page"
            :length="Math.ceil(totalItemsCount / limit)"
            active-color="primary"
          >
          </v-pagination>
        </div>
      </v-window-item>
    </v-window>

    <chat-detail-dialog
      :isOpen="dialog"
      @is-open="dialog = $event"
      :chat="chatDetail"
      :isDraft="tab == 'inDraft'"
    ></chat-detail-dialog>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import PageTitle from "@/components/atoms/PageTitle.vue";
import DatePicker from "@/components/atoms/DatePicker.vue";
// import StaffPicker from '@/components/atoms/StaffPicker.vue'
import MailTableContainer from "@/containers/MailTableContainer.vue";
import { chatModule } from "@/store/dataModules/chatModule";
import LocalDataService from "@/service/LocalDataService";
import { GroupChatResponse } from "chaild-api/lib";
import ChatDetailDialog from "@/components/molecules/ChatDetailDialog.vue";
import dayjs from "dayjs";
import { NurseryUserResponse } from "chaild-api/src/component/nursery/user/types";
import { nurseryUserModule } from "@/store/dataModules/nurseryUserModule";
import ApiChat from "@/api/ApiChat";

interface DataType {
  tab: "delivered" | "inDraft" | "inProgress";
  dialog: boolean;
  loading: boolean;
  chatDetail: GroupChatResponse | null;
  startedAtFilterValue: string;
  endedAtFilterValue: string;
  titleFilterValue: string;
  userIdFilterValue: number | "all";
  limit: number;
  page: number;
}

export default defineComponent({
  name: "Inbox",

  components: {
    PageTitle,
    DatePicker,
    MailTableContainer,
    ChatDetailDialog,
  },

  async mounted() {
    this.loading = true;
    this.startedAtFilterValue = dayjs().format("YYYY-MM-DD");

    const mailInboxStartedAt = sessionStorage.getItem('mailInboxStartedAt');
    const mailInboxEndedAt = sessionStorage.getItem('mailInboxEndedAt');
    const mailInboxTitle = sessionStorage.getItem('mailInboxTitle');
    const mailInboxUserId = sessionStorage.getItem('mailInboxUserId');
    const mailInboxPage = sessionStorage.getItem('mailInboxPage');

    if (mailInboxStartedAt) this.startedAtFilterValue = mailInboxStartedAt;
    if (mailInboxEndedAt) this.endedAtFilterValue = mailInboxEndedAt;
    if (mailInboxTitle) this.titleFilterValue = mailInboxTitle;
    if (mailInboxUserId) this.userIdFilterValue = Number(mailInboxUserId);

    await this.listGroupChats();
    await this.listStaffs(this.startedAtFilterValue);
    if (mailInboxPage) this.page = Number(mailInboxPage);
    this.loading = false;
  },

  watch: {
    filterValues: {
      handler() {
        if (this.filterValues.startedAt) sessionStorage.setItem('mailInboxStartedAt', String(this.filterValues.startedAt)); else sessionStorage.setItem('mailInboxStartedAt', '');
        if (this.filterValues.endedAt) sessionStorage.setItem('mailInboxEndedAt', String(this.filterValues.endedAt)); else sessionStorage.setItem('mailInboxEndedAt', '');
        if (this.filterValues.title) sessionStorage.setItem('mailInboxTitle', String(this.filterValues.title)); else sessionStorage.setItem('mailInboxTitle', '');
        if (this.filterValues.userId) sessionStorage.setItem('mailInboxUserId', String(this.filterValues.userId)); else sessionStorage.setItem('mailInboxUserId', '');

        this.listStaffs(this.startedAtFilterValue);
        this.listGroupChats();
      },
    },
    tab: {
      handler(val) {
        this.startedAtFilterValue = "";
        this.endedAtFilterValue = "";
        this.titleFilterValue = "";
        this.userIdFilterValue = "all";
        this.listGroupChats();
      },
    },
    page: {
      handler() {
        this.listGroupChats();
      },
    },
  },

  data: (): DataType => {
    return {
      tab: "delivered",
      dialog: false,
      loading: false,
      chatDetail: null,
      startedAtFilterValue: "",
      endedAtFilterValue: "",
      titleFilterValue: "",
      userIdFilterValue: "all",
      limit: 10,
      page: 1,
    };
  },

  computed: {
    groupChats: function (): GroupChatResponse[] {
      return chatModule.groupChats;
    },
    drafts: function (): GroupChatResponse[] {
      return chatModule.drafts;
    },
    filterValues() {
      return {
        startedAt: this.startedAtFilterValue,
        endedAt: this.endedAtFilterValue,
        title: this.titleFilterValue,
        userId: this.userIdFilterValue == "all" ? "" : this.userIdFilterValue,
      };
    },
    totalItemsCount: function (): number {
      return chatModule.totalItemsCount;
    },
    staffs: function (): NurseryUserResponse[] {
      return nurseryUserModule.staffs.filter(s => !s.isHidden);
    },
    // セレクトボックスのクラッシュ防止用配列
    staffOptionsList() {
      if (!this.staffs) return [];
      return this.staffs.map(s => ({
        ...s,
        title: `${s.lastName}${s.firstName}`
      }));
    }
  },

  methods: {
    async pageClick(pageNumber: number) {
      if (pageNumber) sessionStorage.setItem('mailInboxPage', String(pageNumber));
    },
    async listGroupChats() {
      this.loading = true;

      const nurseryId = LocalDataService.getNurseryId();
      if (nurseryId) {
        await chatModule.listGroupChats({
          nurseryId: nurseryId,
          status: this.tab,
          ...this.filterValues,
          skip: (this.page - 1) * this.limit,
          limit: this.limit,
        });
      }

      this.loading = false;
    },
    async listStaffs(date: string) {
      const nurseryId = LocalDataService.getNurseryId();
      if (nurseryId) {
        await nurseryUserModule.listStaffs({ date: date });
      }
    },
    clickDetail(item: GroupChatResponse) {
      this.chatDetail = item;
      this.dialog = true;
    },
    async deleteGroupChat(item: GroupChatResponse) {
      const answer = confirm("削除しますか？");
      if (answer) {
        const response = await ApiChat.deleteGroupChat({
          groupChatIds: String(item.groupChatId),
        }).catch(() => (this.loading = false));
        if (response) {
          alert("削除しました");
          await this.listGroupChats();
        }
        this.loading = false;
      }
    },
  },
});
</script>
<style scoped>
.tabs-container {
    margin-top: 40px;
    margin-bottom: 40px; /* 下のマージンを36pxに設定 */
}

:deep(.v-pagination__item--is-active .v-btn) {
  background-color: rgb(var(--v-theme-primary)) !important;
  color: white !important;
  font-weight: bold;
  transform: scale(1.2);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
}
</style>